<template>
  <div class="notice atb-flex atb-flex-column">
    <div class="atb-content-bg atb-flex atb-flex-column">
      <div class="search">
        <el-form :inline="true" :model="searchParam" class="atb-input" @keyup.enter.native="getList('resetPage')" @submit.native.prevent>
          <el-form-item label="消息类型">
            <el-select clearable v-model="searchParam.MsgObjectType" placeholder="消息类型">
              <el-option v-for="item in msgTypeList" :key="item.value" :label="item.label" :value="item.value"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="状态">
            <el-select v-model="searchParam.Status" placeholder="状态">
              <el-option v-for="item in statusList" :key="item.value" :label="item.label" :value="item.value"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="getList('resetPage')">查询</el-button>
          </el-form-item>
        </el-form>
      </div>
      <div class="table-content">
        <vxe-table stripe highlight-hover-row highlight-current-row class="atb-table" border="inner" height="100%" auto-resize :data="tableData" ref="unHandle" @cell-click="goDetail">
          <vxe-table-column type="seq" width="60" title="NO."></vxe-table-column>
          <vxe-table-column field="sendName" title="发信人" width="120"></vxe-table-column>
          <vxe-table-column field="sendNo" title="工号" width="100"></vxe-table-column>
          <vxe-table-column field="recipientName" title="接收人" width="120"></vxe-table-column>
          <vxe-table-column field="msgContent" min-width="500" title="主题"></vxe-table-column>
          <vxe-table-column field="msgObjectType" width="120" title="消息类型">
            <template #default="{ row }">{{
              msgTypeList.find((t) => t.value === row.msgObjectType) ? msgTypeList.find((t) => t.value === row.msgObjectType).label : ''
            }}</template>
          </vxe-table-column>
          <vxe-table-column field="dealDate" width="175" title="时间">
            <template #default="{row}">
              <span>{{ row.creationTime ? XEUtils.toDateString(new Date(row.creationTime)) : '' }}</span>
            </template>
          </vxe-table-column>
          <vxe-table-column field="" title="操作" fixed width='100' class-name='operation'>
            <template #default="scope">
              <el-tooltip class='item' effect='dark' content='撤回' placement="bottom">
                <i v-throttle v-if="scope.row.status === 0" class='icon-chehui' @click.stop='revert(scope.row)'></i>
              </el-tooltip>
            </template>
          </vxe-table-column>
        </vxe-table>
      </div>
      <div class="page-con atb-flex atb-flex-justify-end">
        <vxe-pager
          background
          :current-page.sync="page.PageIndex"
          :page-size.sync="page.PageSize"
          :total="total"
          height="100%"
          @page-change="unHandlePageChange"
          :layouts="['PrevJump', 'PrevPage', 'JumpNumber', 'NextPage', 'NextJump', 'Total']"
        >
        </vxe-pager>
      </div>
    </div>
    <el-dialog title="撤回确认" :visible.sync="showHandle" width="260px" :close-on-click-modal="false" :close-on-press-escape="false">
      <div class="content">
        <h2>确定要撤回吗?</h2>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button class="atb-dialog-confirm" type="primary" @click="confirmHandle">确认</el-button>
        <el-button class="atb-dialog-cancel" type="cancel" @click="showHandle = false">取消</el-button>
      </span>
    </el-dialog>
    <common-dialog ref="modifyApprove" :title="dialogContent.title" width="950px" showClose>
      <template slot="content">
        <component
          v-bind:is="dialogContent.componentName"
          :msgObjectId="dialogContent.msgObjectId"
          :role="dialogContent.role"
          :extend="dialogContent.extend"
          :hideApprove="false"
          @submitSuccess="getList()"
        ></component>
      </template>
    </common-dialog>
    <common-dialog ref="taskApprove" :title="dialogContent.title" width="950px" showClose>
      <template slot="content">
        <component
          v-bind:is="dialogContent.componentName"
          :msgObjectId="dialogContent.msgObjectId"
          :role="dialogContent.role"
          :msgId="dialogContent.msgId"
          :sendName="dialogContent.sendName"
          :hideApprove="false"
          @submitSuccess="getList()"
        ></component>
      </template>
    </common-dialog>
    <common-dialog ref="yearApprove" :title="dialogContent.title" width="950px" showClose>
      <template slot="content">
        <component
          v-bind:is="dialogContent.componentName"
          :msgObjectId="dialogContent.msgObjectId"
          :role="dialogContent.role"
          :msgId="dialogContent.msgId"
          :sendName="dialogContent.sendName"
          :hideApprove="false"
          @submitSuccess="getList()"
        ></component>
      </template>
    </common-dialog>
    <common-dialog ref="todoWorkApprove" :title="dialogContent.title" width="1000px" showClose>
      <template slot="content">
        <component
          v-bind:is="dialogContent.componentName"
          :msgObjectId="dialogContent.msgObjectId"
          :msgObjectChildId="dialogContent.msgObjectChildId"
          :role="dialogContent.role"
          :msgId="dialogContent.msgId"
          :sendName="dialogContent.sendName"
          :workType="dialogContent.workType"
          :sendAction="dialogContent.sendAction"
          @submitSuccess="getList()"
        ></component>
      </template>
    </common-dialog>
    <common-dialog ref="transfer" :title="transferContent.title" width="900px" showClose>
      <template slot="content">
        <component v-bind:is="transferContent.componentName" :role="transferContent.role" :msg="transferContent.msg" :hideApprove="false" @submitSuccess="getList()"></component>
      </template>
    </common-dialog>
  </div>
</template>
<script>
import XEUtils from 'xe-utils';

export default {
  components: {
    modifyApprove: () => import('../../notice/modifyApprove.vue'),
    taskApprove: () => import('../../notice/taskApprove.vue'),
    yearApprove: () => import('../../notice/yearApprove.vue'),
    transfer: () => import('../../notice/transfer.vue'),
    todoWorkApprove: () => import('../../notice/todoWorkApprove.vue'),
  },
  name: 'index',
  data() {
    return {
      XEUtils: XEUtils,
      activeName: 'second',
      showHandle: false,
      handleDelete: true,
      enableHandle: true,
      searchParam: {
        MsgCategory: 3,
        Status: 0,
        MsgObjectType: '',
      },
      page: {
        PageIndex: 1,
        PageSize: 10,
      },
      total: 0,
      tableData: [],
      unHandleList: [],

      dialogContent: {},
      transferContent: {},
      msgTypeList: [],
      that:this,
      statusList: [
        {label: '未撤回', value: 0},
        {label: '已撤回', value: 2}
      ],
      row: {}
    };
  },
  created() {
    this.getList();
    this.getMsgType();
  },
  mounted() {},
  methods: {
    cleatStatus() {
      this.searchParam.Status = null;
    },
    handleClick(tab, event) {
      console.log(tab, event);
    },
    getMsgType() {
      this.$ajax
          .get(this.$api.Identity.BasicData.all, { ItemType: 'MsgObjectType' })
          .then((res) => {
            this.msgTypeList = this.filterMsgType(res.data.rows || []);
          })
          .catch(() => {});
    },
    getList(resetPage) {
      if(resetPage){
        this.page.PageIndex = 1;
      }
      let param = Object.assign({}, this.searchParam, this.page);
      this.$ajax.get(this.$api.withdraw.list, param).then((res) => {
        this.tableData = res.data.rows;
        this.total = res.data.total;
      });
    },

    unHandlePageChange({ currentPage }) {
      this.page.PageIndex = currentPage;
      this.getList();
    },
    goDetail({row,triggerCheckbox}) {
      if(triggerCheckbox){
        return false;
      }
      switch (row.msgObjectType) {
        case 'WeekWork':
          this.$router.push({
            path: '/personal/week/detail',
            query: {
              id: row.msgObjectId,
              status: row.status,
              childIds: Array.isArray(row.msgObjectChildId)?row.msgObjectChildId.join(','):'',
              editStatus: '',
              msgId: row.id,
            },
          });
          break;
        case 'MonthWork':
          this.$router.push({
            path: '/personal/month/detail',
            query: {
              id: row.msgObjectId,
              status: row.status,
              childIds: Array.isArray(row.msgObjectChildId)?row.msgObjectChildId.join(','):'',
              editStatus: '',
              msgId: row.id,
            },
          });
          break;
          // case 'DayWork':
          //   this.$router.push({
          //     path: '/personal/day/detail',
          //     query: {
          //       id: row.msgObjectId,
          //       status: row.status,
          //       editStatus: row.status===0? 'approve': '',
          //     },
          //   });
          //   break;
        case 'YearPlan':
          const yearExtend = JSON.parse(row.extend || '{}');
          const query = {
            id: row.msgObjectId,
            status: row.status,
            editStatus: '',
            childIds: row.msgObjectChildId ? row.msgObjectChildId.join(',') : '',
            msgId: row.id,
          };
          if (yearExtend.Version) {
            this.$router.push({
              path: '/personal/year-plan/detail-next',
              query,
            });
          } else {
            this.$router.push({
              path: '/personal/year-plan/detail',
              query,
            });
          }
          break;
        case 'ModifyWork':
          this.dialogContent = {
            title: '修订审批',
            componentName: 'modifyApprove',
            msgObjectId: row.msgObjectId,
            role: 0,
            extend: row.extend
          };
          this.$refs.modifyApprove.show();
          break;
        case 'PublishMonthWork':
          this.dialogContent = {
            title: '新增工作发布',
            componentName: 'taskApprove',
            msgObjectId: row.msgObjectChildId,
            role: 'revert',
            msgId: row.id,
            sendName: row.sendName
          };
          this.$refs.taskApprove.show();
          break;
        case 'PublishYearWork':
          this.dialogContent = {
            title: '年计划修订',
            componentName: 'yearApprove',
            msgObjectId: row.msgObjectChildId,
            role: 'revert',
            msgId: row.id,
            sendName: row.sendName
          };
          this.$refs.yearApprove.show();
          break;
        case 'TransferWork':
          this.transferContent = {
            title: '转移工作审批',
            componentName: 'transfer',
            msg: row,
            role: 0,
          };
          this.$refs.transfer.show();
          break;
        case 'HandoverWork':
          this.transferContent = {
            title: '交接工作审批',
            componentName: 'transfer',
            msg: row,
            role: 0,
          };
          this.$refs.transfer.show();
          break;
        case 'PeriodResult':
          this.$router.push({
            path: '/period/periodresult/index',
            query: {
              wkNo: row.sendNo,
              msgId: row.id,
              year: row.extend ? JSON.parse(row.extend).Year : '',
              period: row.extend ? JSON.parse(row.extend).Period : '',
              role: 1,
            },
          });
          break;
        case 'WorkScore':
          this.$router.push({
            path: '/personal/workscore/detail',
            query: {
              wkNo: row.sendNo,
              msgId: row.id,
              id: row.msgObjectId,
            },
          });
          break;
        case 'ImportantSort':
          this.$router.push({
            path: '/period/importance-sort/index',
            query: {
              wkNo: row.sendNo,
              msgId: row.id,
              role: 1,
            },
          });
          break;
        case 'OEC':
          let tab;
          if (['OECAmendmentCommit', 'OECAmendmentCommitPassed', 'OECAmendmentCommitRejected'].includes(row.sendAction)) {
            tab = 3;
          }
          this.$router.push({
            path: '/manage/declare',
            query: {
              date: row.extend ? JSON.parse(row.extend).Year + '-' + JSON.parse(row.extend).Month : '',
              tab,
            }
          });
          break;
          case 'PublishMonthTodoWork':
            this.dialogContent = {
              title: '工作待办发布月计划',
              componentName: 'todoWorkApprove',
              msgObjectId: row.msgObjectId,
              msgObjectChildId: row.msgObjectChildId,
              role: 0,
              msgId: row.id,
              sendName: JSON.parse(row.extend).CreatorUserName,
              workType: 'Month',
              sendAction: row.sendAction,
            };
            this.$refs.todoWorkApprove.show();
            break;
          case 'PublishWeekTodoWork':
            this.dialogContent = {
              title: '工作待办发布周计划',
              componentName: 'todoWorkApprove',
              msgObjectId: row.msgObjectId,
              msgObjectChildId: row.msgObjectChildId,
              role: 0,
              msgId: row.id,
              sendName: JSON.parse(row.extend).CreatorUserName,
              workType: 'Week',
              sendAction: row.sendAction,
            };
            this.$refs.todoWorkApprove.show();
            break;
      }
    },
    revert(row) {
      this.row = row;
      this.showHandle = true;
    },
    confirmHandle() {
      this.$ajax.put(this.$api.withdraw.revert, `"${this.row.id}"`, { headers: { 'Content-Type': 'application/json;charset=UTF-8;' }}).then(res => {
        this.$message.success(res.message);
        this.showHandle = false;
        this.getList();
      });
    }
  },
};
</script>
<style scoped lang="scss">
.notice {
  height: 100%;
  .atb-content-bg {
    padding: 20px;
    flex: 1;
  }
  ::v-deep .tab{
    margin-top: -3px;
  }
  ::v-deep .el-dialog__body {
    padding-top: 33px !important;
    text-align: center;
    h2 {
      font-size: 18px;
      color: $--color-text-primary;
      font-weight: bold;
      margin-bottom: 10px;
    }
    p {
      color: $--color-text-regular;
    }
  }
  ::v-deep .el-dialog__footer {
    text-align: center;
  }
}
</style>
